(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["trident-editorial"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ready = new WeakSet();
  const initialise = () => {
    document.querySelectorAll('.td-edit--products').forEach(section => {
      if (ready.has(section)) return;
      const grid = section.querySelector('.td-grid');
      const controls = section.querySelector('.td-swipe-buttons');
      if (!grid || !controls) return;
      ready.add(section);
      const previous = controls.querySelector('[data-td-previous]');
      const next = controls.querySelector('[data-td-next]');
      const update = () => {
        const maximum = grid.scrollWidth - grid.clientWidth;
        controls.hidden = maximum <= 2;
        previous.disabled = grid.scrollLeft <= 2;
        next.disabled = grid.scrollLeft >= maximum - 2;
      };
      const move = direction => {
        const card = grid.querySelector('.td-card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
        grid.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      grid.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(grid);
      update();
    });
  };
  initialise();
  document.addEventListener('shopify:section:load', initialise);
})();

  } catch(e) { console.error(e); }
})();
})();
